import {
  CreatePaymentLinkPayload,
  LastOrderResponse,
  ListPaymentLinksResponse,
  ListPaymentLinksPayload,
  PaymentLinkDetail,
  PaymentOptionsPayload,
  PaymentOptionsResponse,
  PurchaseIntentionResponse,
  LimitReservationRequest,
  LimitReservationResponse,
  ValidatePaymentLinkPayload,
  ValidatePaymentLinkResponse,
} from '@types'

import { Service } from '@tino-frontend/adapters'

export class ClientOrderService {
  constructor(private readonly http: Service) {}

  async getLastMerchantOrderDetails(
    supplierId: string,
    merchantDocumentNumber: string,
    userId: string
  ): Promise<LastOrderResponse> {
    return this.http.get(
      `/v1/suppliers/${supplierId}/latest-order?creator_user_id=${userId}&merchant_document_number=${merchantDocumentNumber}`
    )
  }

  create(
    payload: CreatePaymentLinkPayload
  ): Promise<PurchaseIntentionResponse> {
    return this.http.post('/v1/payment-links', payload)
  }

  getPaymentOptions(
    payload: PaymentOptionsPayload
  ): Promise<PaymentOptionsResponse> {
    return this.http.get('/v1/payment-options', {
      params: payload,
    })
  }

  validate(
    payload: ValidatePaymentLinkPayload
  ): Promise<ValidatePaymentLinkResponse> {
    return this.http.post('/v1/payment-links/validate', payload)
  }

  list(params: ListPaymentLinksPayload): Promise<ListPaymentLinksResponse> {
    return this.http.get('/v1/payment-links', {
      params,
    })
  }

  getDetail(id: string): Promise<PaymentLinkDetail> {
    return this.http.get(`/v1/payment-links/${id}`)
  }

  resend({
    purchaseIntentionId,
    supplierCompanyId,
  }: {
    purchaseIntentionId: string
    supplierCompanyId: string
  }) {
    return this.http.post(
      `/v1/payment-links/${purchaseIntentionId}/resend?supplier_company_id=${supplierCompanyId}`
    )
  }

  reservePayment(
    payload: LimitReservationRequest
  ): Promise<LimitReservationResponse> {
    return this.http.post('/v1/limit-reservations', payload)
  }
}
